import React from 'react'
import { getShow } from 'redux/slices/liveShow'
import { useSelector } from 'react-redux'

import ShowCard from 'components/set/PaywallPrompt/ShowCard'
import { useStyles } from './styles'
import RedeemCode from 'components/set/RedeemCode/RedeemCode'

const ReedemOnly: React.FC = () => {
    const classes = useStyles()
    const show = useSelector(getShow)

    return (
        <div className={classes.paywallWrapper}>
            {show && <ShowCard show={show} />}
            <RedeemCode />
        </div>
    )
}

export default React.memo(ReedemOnly)
